export default "__VITE_ASSET__mf9Zvyb5__"